import { valueProps } from "@/mocks/home";

export default function ValueProps() {
  return (
    <section id="value" className="relative bg-background-50 py-20 md:py-24 px-4 md:px-8">
      <div className="max-w-6xl mx-auto">
        <div className="reveal max-w-3xl mb-14">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-foreground-950 leading-tight tracking-tight">
            You&apos;re losing money.
            <br />
            Every day. <span className="text-foreground-600">Every missed enquiry.</span>
          </h2>
          <p className="mt-5 text-base text-foreground-700 leading-relaxed max-w-xl">
            Missed calls. Slow replies. Dead contact forms. No-shows. Joble plugs every leak in one
            move so every opportunity gets an answer.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {valueProps.map((prop, index) => (
            <div
              key={prop.title}
              className={`reveal h-full rounded-2xl border border-background-300/40 bg-background-100/50 backdrop-blur p-7 md:p-8 flex flex-col gap-5 hover:border-primary-500/40 hover:bg-background-100/80 transition-all duration-300 ${
                index === 1 ? "md:mt-6" : ""
              }`}
            >
              <div
                className={`w-11 h-11 rounded-xl flex items-center justify-center ${
                  index === 1
                    ? "bg-accent-500/12 border border-accent-500/25"
                    : "bg-primary-500/12 border border-primary-500/25"
                }`}
              >
                <i
                  className={`${prop.icon} text-xl ${index === 1 ? "text-accent-400" : "text-primary-400"}`}
                  aria-hidden
                ></i>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-foreground-950 mb-2">{prop.title}</h3>
                <p className="text-sm text-foreground-700 leading-relaxed">{prop.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}